import { FlowService } from 'services/flow.service';
import { FlowResultDto } from './../../dto/FlowResultDto';
import { NodeUi } from 'classes/NodeUi';
import { FlowUi } from 'classes/FlowUi';
import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'payload',
  templateUrl: './payload.component.html',
  styleUrls: ['./payload.component.css']
})
export class PayloadComponent implements OnChanges{
  
  @Input() flow:FlowUi;
  @Input() result:FlowResultDto;

  data:any[];

  constructor(private flowService:FlowService) { }

  ngOnChanges() {

    this.data = [];
    if (this.result && this.result.Payload)
      for(let ix in this.result.Payload)
        this.data.push({key:ix,value:JSON.stringify(this.flow.FlowResult.Payload[ix]),node:this.flow.Nodes.find(x => x.dto.Identifier == ix)});
  }

  mouseOver(node:NodeUi){
    if (node)
      node.Highlight = true;
  }

  mouseOut(node:NodeUi){
    if (node)
      node.Highlight = false;
  }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/payload/payload.component.ts